import React from "react"
import * as styles from "./Card.module.css"
import elementSplitter from "../utils/elementSplitter"

type CardProps = {
  children: React.ReactElement
  simple?: boolean
}

const Card = ({ children, simple }: CardProps) => {
  const { svgs, headers, paragraphs, components } = elementSplitter(children)

  if (simple) return <div className={styles.simpleContent}>{children}</div>
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {svgs}
        {headers}
      </div>
      {paragraphs}
      {components}
    </div>
  )
}

export default Card
